module.exports = __webpack_public_path__ + "8b995c0a8329d8698f9945b4c04d4bdf.svg";